import type { Factura } from "../api/tipos.ts";

/**
 * Quién es el cliente, deducido de las facturas elegidas (SPEC-028 §4.2).
 *
 * Las facturas llevan documento obligatorio, así que elegir una registrada da
 * identidad y nombre canónico de una vez — y el nombre deja de depender de que
 * alguien teclee igual dos veces con semanas de diferencia, que es lo que
 * garantiza que el aprendizaje se rompa antes o después.
 *
 * **Si las elegidas no coinciden en cliente, no devuelve nada.** Que un pago
 * cubra facturas de dos clientes es posible pero raro; elegir cuál manda sería
 * inventar, y devolver vacío deja a la vista que ahí hay algo que mirar.
 *
 * Vive fuera del componente porque es una regla, no una pantalla: el día que
 * alguien añada otra forma de elegir facturas, la regla sigue siendo esta.
 */
export function identidadDe(
  elegidas: string[],
  cartera: Factura[],
): { nit: string; cliente: string } | null {
  const encontradas = elegidas
    .map((n) => cartera.find((f) => f.numero.trim().toLowerCase() === n.trim().toLowerCase()))
    .filter((f): f is Factura => !!f);

  if (!encontradas.length) return null;

  // Se compara por documento, no por nombre: es la identidad, y dos facturas
  // del mismo cliente pueden traer el nombre escrito distinto desde el ERP.
  const nits = new Set(encontradas.map((f) => (f.nit ?? "").trim()).filter(Boolean));
  if (nits.size !== 1) return null;

  const nit = [...nits][0] ?? "";
  const conNombre = encontradas.find((f) => (f.cliente ?? "").trim());
  return { nit, cliente: (conNombre?.cliente ?? "").trim() };
}
